import trackPageView from "./actions/trackPageView";

export default {
    ini() {
        trackPageView.trackShareFormPageView();
    }
}
